import { enqueueSnackbar } from "notistack";

const fireAlert = (
  msg: string,
  variant?: "success" | "default" | "error" | "warning" | "info" | undefined,
  vertical?: "top" | "bottom",
  horizontal?: "left" | "center" | "right",
) => {
  enqueueSnackbar(msg || getDefaultMsg(variant), {
    variant: variant ?? "success",
    anchorOrigin: {
      vertical: vertical ?? "top",
      horizontal: horizontal ?? "center",
    },
  });
};
export default fireAlert;

const getDefaultMsg = (variant: "success" | "default" | "error" | "warning" | "info" | undefined) => {
  switch (variant) {
    case "success":
      return "تمت العملية بنجاح";
    case "error":
      return "حدث خطأ ما";
    case "warning":
      return "تحذير";
    case "info":
      return "معلومات";
    default:
      return "";
  }
}